export default __webpack_public_path__ + "static/media/scrumCoach_icon.79991925.webp";